<template>
  <v-row id="onsite_payments" class="docScroll">
    <HeaderTemplate :data="contentHeader" />
    <SectionColumn type="left" :content="sectionTwoLeft" title="Integration" />
    <SectionColumn type="right" :content="sectionTwoRight" />
    <SectionColumn type="left" :content="sectionThreeLeft" />
    <SectionColumn type="right" :content="sectionThreeRight" />
    <SectionColumn type="left" :content="sectionFourLeft" />
    <SectionColumn type="right" :content="sectionFourRight" />
    <SectionColumn type="left" :content="sectionFiveLeft" />
    <SectionColumn type="right" :content="sectionFiveRight" />
    <SectionColumn type="left" :content="sectionSixLeft" />
    <SectionColumn type="right" :content="sectionSixRight" />
    <SectionColumn type="full" :content="sectionConfirmation" />
  </v-row>
</template>

<script>
import HeaderTemplate from "../../../components/templates/HeaderTemplate";
import SectionColumn from "../../../components/layout/SectionColumn";

export default {
  name: "OnSitePayments",
  components: {
    HeaderTemplate,
    SectionColumn,
  },
  data() {
    return {
      contentHeader: {
        title: "Onsite Payments (Beta)",
        svg: `<svg width="29" height="29" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="20.5" r="20.5" fill="#E12E56"/><path d="M31 27.25V30H28.25H11.75H9V27.25V18.5188L9.17617 18.6434L19.6004 26.0898L20 26.3734L20.3996 26.0898L30.8238 18.6434L31 18.5188V27.25ZM31 16.25V16.8301L30.0246 17.5262L26.875 19.7777V16.5938V14.1875V13.1562V12.125H25.5H24.8125H20.9152H19.0848H15.1875H14.5H13.125V13.1562V14.1875V16.5938V19.7777L9.97539 17.5262L9 16.8301V16.25L11.0625 14.7031V12.125V10.0625H13.125H17.25L20 8L22.75 10.0625H26.875H28.9375V12.125V14.7031L31 16.25ZM20.8594 14.1875V14.4582C21.143 14.5098 21.577 14.5957 21.766 14.6473L22.5953 14.8664L22.1527 16.5293L21.3234 16.3102C21.1602 16.2672 20.5758 16.1512 20.391 16.1254C19.8668 16.0437 19.4371 16.1125 19.1621 16.2371C18.8914 16.3617 18.8227 16.5035 18.8098 16.5852C18.784 16.7312 18.8098 16.7871 18.8141 16.8C18.827 16.8215 18.857 16.8773 18.9688 16.9504C19.2309 17.1309 19.6434 17.2598 20.2535 17.4402L20.2879 17.4488C20.8078 17.6078 21.5039 17.8141 22.0238 18.1965C22.3117 18.407 22.5824 18.6863 22.75 19.0773C22.9219 19.4684 22.9563 19.898 22.8789 20.3406C22.7371 21.157 22.1957 21.7156 21.5211 22.0035C21.3105 22.0938 21.0871 22.1582 20.8594 22.2012V22.4375V23.2969H19.1406V22.4375V22.1625C18.7324 22.068 18.1953 21.8875 17.8559 21.7715C17.7828 21.7457 17.7184 21.7242 17.6668 21.707L16.8504 21.4363L17.3918 19.8035L18.2082 20.0742C18.2941 20.1043 18.3887 20.1344 18.4832 20.1645C18.8914 20.302 19.3512 20.4609 19.609 20.5039C20.159 20.5898 20.5844 20.534 20.8465 20.4223C21.0828 20.3234 21.1645 20.1945 21.1902 20.0441C21.2203 19.8723 21.1945 19.7906 21.1816 19.7563C21.1645 19.7176 21.1258 19.6617 21.0184 19.5844C20.7648 19.3996 20.3609 19.2621 19.7594 19.0816L19.6648 19.0516C19.1621 18.9012 18.5047 18.7035 18.0063 18.3641C17.7227 18.1707 17.4391 17.9043 17.2629 17.5262C17.0824 17.1395 17.0395 16.7184 17.1168 16.2801C17.2543 15.4938 17.8129 14.9523 18.4531 14.6602C18.668 14.5613 18.9 14.4883 19.1406 14.441V14.1832V13.3281H20.8594V14.1875Z" fill="white"/></svg>`,
        text: `Integrate Payfast’s secure payment engine directly into the checkout page.`,
      },
      sectionTwoLeft: [
        {
          doc_section_content_id: 1,
          template: "standard",
          data: {
            text: `<p>Integration is a simple two step process:</p>`,
          },
        },
        {
          doc_section_content_id: 2,
          template: "alert",
          data: {
            type: "warning",
            msg: "<b>Important:</b> Please note that for security reasons Onsite Payments requires that your application be served over <b>HTTPS</b>.",
          },
        },
      ],
      sectionTwoRight: [
        {
          doc_section_content_id: 3,
          template: "standard",
          data: {
            text: `<div class="videoWrapper"><iframe width="560" height="315" src="https://www.youtube.com/embed/3dBxdvCmkOU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`,
          },
        },
      ],
      sectionThreeLeft: [
        {
          doc_section_content_id: 4,
          template: "standard",
          data: {
            text: `<h3 class='mb-1'>Step 1: Post payment details and get a unique payment identifier</h3>
                    <p>The transaction and customer details need to be sent to Payfast before any customer interaction.</p>
                    <p><b>Live</b>: https://www.payfast.co.za/onsite/&#8203;process<br>
                    <b>Sandbox</b>: https://sandbox.payfast.co.za/onsite/&#8203;process`,
          },
        },
        {
          doc_section_content_id: 6,
          template: "standard",
          data: {
            text: `<b>POST Data:</b><br>
                    The POST data that is required can be found in the <a href="/docs#step_1_form_fields" class="link--text">Quickstart guide</a>.`,
          },
        },
        {
          doc_section_content_id: 7,
          template: "attributes",
          data: {
            title: "The following are additional requirements for Onsite",
            items: [
              {
                name: "signature",
                type: "string",
                required: true,
                required_text: "REQUIRED",
                description:
                  "The signature is a hash of the posted data used to ensure the integrity of the data transfer",
              },
              {
                name: "email_address",
                type: "string, 100 char ",
                required: true,
                required_text: "REQUIRED UNLESS MOBILE REGISTRATION ALLOWED",
                description:
                  "The customer’s email address. This is required unless the merchant has specifically allowed mobile registration from their account.",
              },
              {
                name: "cell_number",
                type: "string, 100 char ",
                required: true,
                required_text: "REQUIRED IF EMAIL NOT SET",
                description:
                  "The customer’s valid cell number. If the email_address field is empty, and cell_number provided, the system will use the cell_number as the username and auto login the user, if they do not have a registered account",
              },
            ],
          },
        },
        {
          doc_section_content_id: 8,
          template: "alert",
          data: {
            type: "info",
            msg: "If no return_url is submitted, the modal will just close on payment completion and customers will not be redirected to a success page.",
          },
        },
      ],
      sectionThreeRight: [
        {
          doc_section_content_id: 9,
          template: "request",
          data: {
            title: "",
            method: "POST",
            endpoint: "/onsite/process",
            language: "html",
            code: "https://www.payfast.co.za/onsite/process",
          },
        },
        {
          doc_section_content_id: 10,
          template: "response",
          data: {
            title: "RESPONSE",
            json: { uuid: "123-abc" },
          },
        },
        {
          doc_section_content_id: 11,
          template: "request",
          data: {
            title: "Payment identifier generation",
            language: "bash",
            code: {
              PHP: `<?php
$passPhrase = 'jt7NOE43FZPn';
$data = [
    'merchant_id' => '10000100',
    'merchant_key' => '46f0cd694581a',
    ...
];

function dataToString($dataArray) {
  // Create parameter string
    $pfOutput = '';
    foreach( $dataArray as $key => $val ) {
        if($val !== '') {
            $pfOutput .= $key .'='. urlencode( trim( $val ) ) .'&';
        }
    }
    // Remove last ampersand
    return substr( $pfOutput, 0, -1 );
}

function generatePaymentIdentifier($pfParamString, $pfProxy = null) {
    // Use cURL (if available)
    if( in_array( 'curl', get_loaded_extensions(), true ) ) {
        // Variable initialization
        $url = 'https://www.payfast.co.za/onsite/process';

        // Create default cURL object
        $ch = curl_init();

        // Set cURL options - Use curl_setopt for greater PHP compatibility
        // Base settings
        curl_setopt( $ch, CURLOPT_USERAGENT, NULL );  // Set user agent
        curl_setopt( $ch, CURLOPT_RETURNTRANSFER, true );      // Return output as string rather than outputting it
        curl_setopt( $ch, CURLOPT_HEADER, false );             // Don't include header in output
        curl_setopt( $ch, CURLOPT_SSL_VERIFYHOST, 2 );
        curl_setopt( $ch, CURLOPT_SSL_VERIFYPEER, true );

        // Standard settings
        curl_setopt( $ch, CURLOPT_URL, $url );
        curl_setopt( $ch, CURLOPT_POST, true );
        curl_setopt( $ch, CURLOPT_POSTFIELDS, $pfParamString );
        if( !empty( $pfProxy ) )
            curl_setopt( $ch, CURLOPT_PROXY, $pfProxy );

        // Execute cURL
        $response = curl_exec( $ch );
        curl_close( $ch );
        echo $response;
        $rsp = json_decode($response, true);
        if ($rsp['uuid']) {
            return $rsp['uuid'];
        }
    }
    return null;
}

// Generate signature (see Custom Integration -> Step 2)
$data["signature"] = generateSignature($data, $passPhrase);

// Convert the data array to a string
$pfParamString = dataToString($data);

// Generate payment identifier
$identifier = generatePaymentIdentifier($pfParamString);`,
              "Node.js":
                `const axios = require("axios");

const myData = {
  "merchant_id": "10000100",
  "merchant_key": "46f0cd694581a",
  ...
};
const passPhrase = 'jt7NOE43FZPn';

const dataToString = (dataArray) => {
  // Convert your data array to a string
  let pfParamString = "";
  for (let key in dataArray) {
    if(dataArray.hasOwnProperty(key)){` +
                'pfParamString +=`${key}=${encodeURIComponent(dataArray[key].trim()).replace(/%20/g, "+")}&`;' +
                `}
  }
  // Remove last ampersand
  return pfParamString.slice(0, -1);
};

const generatePaymentIdentifier = async (pfParamString) => {
  const result = await axios.post(\`https://www.payfast.co.za/onsite/process\`, pfParamString)
      .then((res) => {
        return res.data.uuid || null;
      })
      .catch((error) => {
        console.error(error)
      });
  console.log("res.data", result);
  return result;
};

// Generate signature (see Custom Integration -> Step 2)
myData["signature"] = generateSignature(myData, passPhrase);

// Convert the data array to a string
const pfParamString = dataToString(myData);

// Generate payment identifier
const identifier = await generatePaymentIdentifier(pfParamString);`,
              Python: `import requests
import hashlib
import urllib.parse

myData = {
    'merchant_id':'10000100',
    'merchant_key': '46f0cd694581a',
    ...
    }

def dataToString(dataArray, passPhrase = ''):
    pfParamString = ""
    for key in dataArray:
        # Get all the data from Payfast and prepare parameter string
        pfParamString += key + "=" + urllib.parse.quote_plus(dataArray[key].replace("+", " ")) + "&"
    # After looping through, cut the last & or append your passphrase
    pfParamString = pfParamString[:-1]
    if passPhrase != '':
        pfParamString += f"&passphrase={passPhrase}"
    return pfParamString

def generatePaymentIdentifier(pfParamString):
    url = "https://www.payfast.co.za/onsite/process"
    headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
        }
    response = requests.post(url, data=pfParamString, headers=headers)
    try:
        responseJson = response.json()
        uuid = responseJson.get('uuid')
        return uuid
    except:
        return False


def generateSignature(dataArray, passPhrase = ''):
    payload = dataToString(dataArray, passPhrase)
    return hashlib.md5(payload.encode()).hexdigest()

# Generate signature
passPhrase = 'jt7NOE43FZPn'
myData["signature"] = generateSignature(myData, passPhrase)

# Convert the data array to a string
pfParamString = dataToString(myData, passPhrase);

# Generate payment identifier
identifier = generatePaymentIdentifier(pfParamString);`,
              cURL: `curl -X POST \\
https://www.payfast.co.za/onsite/process \\
-H 'Accept: */*' \\
-H 'Cache-Control: no-cache' \\
-H 'Connection: keep-alive' \\
-H 'Content-Type: application/x-www-form-urlencoded' \\
-H 'Host: transaction.local' \\
-H 'accept-encoding: gzip, deflate' \\
-H 'cache-control: no-cache' \\
-H 'content-length: 246' \\
-d
'merchant_id=10000100&merchant_key=46f0cd694581a&item_name=Test%20Item&item_descrip
tion=Test%20Description&amount=100&name_first=Test&name_last=User&email_address=test1
%40test.com&m_payment_id=9876&notify_url=https%3A%2F%2Fnotify.me%2Fof%2Fpayment'`,
            },
            codeExamples: ["PHP", "Node.js", "Python", "cURL"],
          },
        },
      ],
      sectionFourLeft: [
        {
          doc_section_content_id: 12,
          template: "standard",
          data: {
            text: `<h3 class='mb-1'>Step 2: Trigger the modal popup</h3>
                    <p>Once you have successfully retrieved the above UUID for the payment you can pass that into the Javascript for the payment page initialisation.<br>
                    Place the following script inside of your document <b><head></b> to initialise the payment modal on your website.</p>`,
          },
        },
        {
          doc_section_content_id: 13,
          template: "standard",
          data: {
            text: `There are 2 initialisation options for the modal that can be used depending on how you would like payment completion to be handled.`,
          },
        },
      ],
      sectionFourRight: [
        {
          doc_section_content_id: 14,
          template: "request",
          data: {
            title: "Onsite activation script",
            language: "html",
            code:
              '<script src="https://www.payfast.co.za/onsite/engine.js"><' +
              "/script>",
          },
        },
      ],
      sectionFiveLeft: [
        {
          doc_section_content_id: 15,
          template: "standard",
          data: {
            text: `<b>Method 1: Simple</b>
                    <p>This is the simplest method of triggering the payment modal.<br>
                    All that is needed is to specify the <b>uuid</b> you received in the first step.<br>
                    On payment success the buyer is redirected to your return url. </p>
                    <p>Additionally, if you did not specify the return and cancel urls while getting the unique identifier in step 1, you can add these to the call in this step.</p>`,
          },
        },
      ],
      sectionFiveRight: [
        {
          doc_section_content_id: 16,
          template: "request",
          data: {
            title: "Method 1 - Simple",
            language: "javascript",
            code: `window.payfast_do_onsite_payment({"uuid":"123-abc"});`,
          },
        },
        {
          doc_section_content_id: 17,
          template: "request",
          data: {
            title: "Method 1 - With URLs",
            language: "javascript",
            code:
              "window.payfast_do_onsite_payment({\n" +
              '  "uuid":"123-abc",\n' +
              '  "return_url":"http://example.com",\n' +
              '  "cancel_url":"http://example.com"\n' +
              "});",
          },
        },
      ],
      sectionSixLeft: [
        {
          doc_section_content_id: 18,
          template: "standard",
          data: {
            text: `<b>Method 2: Callback</b>
                    <p>This method is triggered in the same way as the simple method, the difference is that with this method you can define a callback method.<br>
                    On a final action (either a success or the user closing the popup) a call to the callback defined will be fired.</p>`,
          },
        },
        {
          doc_section_content_id: 19,
          template: "alert",
          data: {
            type: "warning",
            msg: "<b>Important:</b> When using the callback method, only the callback will be triggered and any return or cancel urls specified will be ignored!",
          },
        },
      ],
      sectionSixRight: [
        {
          doc_section_content_id: 20,
          template: "request",
          data: {
            title: "Method 2 - Callback",
            language: "javascript",
            code:
              'window.payfast_do_onsite_payment({"uuid":"123-abc"}, function (result) {\n' +
              "  if (result === true) {\n" +
              "    // Payment Completed\n" +
              "  }\n" +
              "  else {\n" +
              "    // Payment Window Closed\n" +
              "  }\n" +
              "});",
          },
        },
      ],
      sectionConfirmation: [
        {
          doc_section_content_id: 21,
          template: "standard",
          data: {
            text: `<h2 class="mb-2">Payment Confirmation</h2>
                    <p>A payment confirmation notification will be sent to the "notify_url" you specified.<br>The full implementation details can be found <a href="#step_4_confirm_payment" class="link--text">here</a>.</p>`,
          },
        },
      ],
    };
  },
};
</script>

<style scoped></style>
